import React, { useMemo, useEffect } from 'react'
import AiReadinessForm from '../components/AiReadiness/AiReadinessForm.jsx'
import { AiReadinessProvider, useAiReadiness } from '../context/AiReadinessContext.jsx'
import QuestionsFormLayout from '../components/AiReadiness/components/AiReadinessLayout.jsx'
import AiReadinessWelcomePage from '../components/AiReadiness/AiReadinessWelcomePage.jsx'
import AiReadinessOutcome from '../components/AiReadiness/AiReadinessOutcome.jsx'
import AiReadinessQuestionSelection from '../components/AiReadiness/components/AiReadinessQuestionFlow.jsx'
import ContactDetailsImg from '../assets/ai-readiness/contact_details.webp';
import Question1 from '../assets/ai-readiness/Q1.png';
import Question2 from '../assets/ai-readiness/Q2.png';
import Question3 from '../assets/ai-readiness/Q3.png';
import Question4 from '../assets/ai-readiness/Q4.png';
import Question5 from '../assets/ai-readiness/Q5.png';
import Question6 from '../assets/ai-readiness/Q6.png';
import Question7 from '../assets/ai-readiness/Q7.png';

// Preload all images on app load
const preloadImages = (imageSources) => {
    imageSources.forEach((src) => {
        const imgElement = new window.Image();
        imgElement.src = src;
    });
};

function AIReadinessContent() {
    const { step, currentIndex } = useAiReadiness()

    const questionImages = useMemo(() => [
        Question1, Question2, Question3, Question4, Question5, Question6, Question7
    ], [])

    const currentQuestionImage = useMemo(() => {
        return questionImages[currentIndex] || Question1
    }, [currentIndex, questionImages])

    return (
        <>
            {step === 0 && <AiReadinessWelcomePage />}
            {step === 1 && <QuestionsFormLayout FormComponent={AiReadinessQuestionSelection} Image={currentQuestionImage} />}
            {step === 2 && <QuestionsFormLayout FormComponent={AiReadinessForm} Image={ContactDetailsImg} />}
            {step === 3 && <AiReadinessOutcome />}
        </>
    )
}

export default function AIReadiness() {
    useEffect(() => {
        // Preload all question images and contact details image on mount
        preloadImages([Question1, Question2, Question3, Question4, Question5, Question6, Question7, ContactDetailsImg]);
    }, []);

    return (
        <AiReadinessProvider>
            <AIReadinessContent />
        </AiReadinessProvider>
    )
}
